import i18n from 'i18next';
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import enLocal from "../locales/en/translation_en.json";

console.log("locale", enLocal);
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // lng: localStorage.getItem("i18nextLng") || LANGUAGES.AMHARIC.value,
        lng: "en",
        resources: {
            /* Add multiple languages here  */
            en: {
                translation: enLocal,
            },
        },
            // fallbackLng: localStorage.getItem("i18nextLng") || LANGUAGES.AMHARIC.value,
            fallbackLng: "en",
            debug: true,
            interpolation: {
            escapeValue: false,
        },
    });

const handleLanguageChange = (newLanguage: any) => {
    console.log(`languageChanged ${newLanguage}`);
};

// const storedLanguage = localStorage.getItem("i18nextLng");
const storedLanguage = "en";

if (storedLanguage) {
    i18n.changeLanguage(storedLanguage);
} else {
    i18n.changeLanguage("en");
}

// Subscribe to the languageChanged event
i18n.on("languageChanged", handleLanguageChange);

export default i18n;
